"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var prop_types_1 = require("prop-types");

require("./index.css");

var Tooltip = function (_a) {
  var direction = _a.direction,
      tip = _a.tip,
      dataTestId = _a.dataTestId,
      unthemed = _a.unthemed,
      showingInitial = _a.showingInitial,
      children = _a.children,
      props = __rest(_a, ["direction", "tip", "dataTestId", "unthemed", "showingInitial", "children"]);

  var toolTipShown = false;

  var _b = (0, react_1.useState)(toolTipShown),
      toolTipShowing = _b[0],
      setToolTipShowing = _b[1];

  var classes = "ui-tooltip ui-tooltip-" + direction;
  classes += unthemed ? ' ui-tooltip-unthemed' : '';
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: classes,
    "data-testid": "tooltip",
    onMouseEnter: function () {
      setToolTipShowing(true);
    },
    onMouseLeave: function () {
      setToolTipShowing(false);
    }
  }, props, {
    children: [children, toolTipShowing && (0, jsx_runtime_1.jsx)("span", __assign({
      className: "ui-tooltip-tip",
      "data-testid": dataTestId
    }, {
      children: tip
    }), void 0), showingInitial && (0, jsx_runtime_1.jsx)("span", __assign({
      className: "ui-tooltip-tip",
      "data-testid": dataTestId
    }, {
      children: tip
    }), void 0)]
  }), void 0);
};

Tooltip.propTypes = {
  direction: (0, prop_types_1.oneOf)(['top', 'right', 'bottom', 'left']),
  tip: prop_types_1.string.isRequired,
  dataTestId: prop_types_1.string,
  showingInitial: prop_types_1.bool,
  unthemed: prop_types_1.bool
};
Tooltip.defaultProps = {
  direction: 'top',
  dataTestId: 'tooltip',
  showingInitial: false,
  unthemed: false
};
exports.default = Tooltip;